import styled, { css } from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getIcon } from 'styles/icons';
import { getColor, type Theme } from 'styles/theme';

const typography = css`
  font-family: ${font.graphikCond};
  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;
`;

export const Container = styled.div<{ theme: Theme }>`
  padding: 8px 20px;
  border-bottom: 1px solid ${getColor('borderSecondary')};
  background-color: ${getColor('surfaceWhite')};
  
  &.sticky-disclosure {
    box-shadow: inset 0px 10px 10px ${getColor('textPrimary')}0D;
  }

  &.crypto {
    border-bottom: none;
  }

  &.landingPage {
    @media (${breakpoint.mdMin}) {
      border-bottom: none;
      padding: 8px 0 0;
    }
    @media (${breakpoint.lgMin}) {
      padding: 8px 0 0;
    }
    @media (${breakpoint.xxlMin}) {
      padding: 8px 0 0;
    }

    & > div {
      @media (${breakpoint.mdMin}) {
        border-bottom: 1px solid ${getColor('borderSecondary')};
        padding-bottom: 8px;
      }
    }
  }
`;

export const Wrapper = styled.div<{ theme: Theme }>`
  text-align: center;
  font-family: ${font.graphikCond};
  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;

  a {
    color: ${getColor('textLink')};
    text-decoration: none;

    &:hover {
      color: ${getColor('textSecondary')};
    }
  }

  @media (${breakpoint.mdMin}) {
    text-align: center;
  }
`;

export const ButtonAsLink = styled.button<{ theme: Theme }>`
  ${typography};
  border-bottom: 1px solid ${getColor('borderBlack')};
    
  &:hover {
    color: ${getColor('textLink')};
  }
    
  &:focus {
    color: ${getColor('textSecondary')};
  }
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  ${typography};
`;

export const Dropdown = styled.div<{ theme: Theme }>`
  position: absolute;
  width: 100%;
  min-width: 230px;
  height: auto;
  top: 29px;
  right: 0;
  background-color: ${getColor('surfaceWhite')};
  z-index: 2;
  box-shadow: 0px 4px 4px 0px ${getColor('surfaceBlack')}19;
  padding: 4px 8px 8px 8px;
  text-align: left;

  border-radius: 4px;
  border: 1px solid ${getColor('borderSecondary')};

  @media screen and (max-width: 22.5rem) {
    right: inherit;
  }

  @media screen and (min-width: 29.063rem) and (max-width: 42.45rem) {
    right: inherit;
  }
`;

export const DropdownHeader = styled.div<{ theme: Theme }>`
  display: flex;
  justify-content: flex-end;

  .close {
    cursor: pointer;
    ${getIcon('svg-states')};

    &::before {
      ${getIcon('close-icon-bold', { height: 8, width: 8 })};
      background-color: ${getColor('neutralBlack')};
    }
  }
`;
